"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useMemo } from "react";
import { useMatch } from "fansunited-data-layer/client";
import { MatchLineupField } from "@/views/match/partials/lineups/MatchLineupField";
import { SubstitutionsSection } from "@/views/match/partials/lineups/SubstitutionsSection";
import { extractSubstitutions } from "@/views/match/partials/lineups/playerEventsHelper";
import { PillToggle } from "@/components/ui/controls/PillToggle";
import { useLabels } from "@/lib/labels/LabelsProvider";
interface EmbeddedLineupsProps {
  homeTeamName: string;
  awayTeamName: string;
  homeTeamCode?: string;
  awayTeamCode?: string;
  homeTeamLogo?: string;
  awayTeamLogo?: string;
  homeTeamPrimaryColor?: string;
  homeTeamSecondaryColor?: string;
  homeTeamCountryCode?: string;
  homeTeamCountryFlag?: string;
  awayTeamPrimaryColor?: string;
  awayTeamSecondaryColor?: string;
  awayTeamCountryCode?: string;
  awayTeamCountryFlag?: string;
}
export function EmbeddedLineups(t0) {
  const $ = _c(53);
  const {
    homeTeamName,
    awayTeamName,
    homeTeamCode,
    awayTeamCode,
    homeTeamLogo,
    awayTeamLogo,
    homeTeamPrimaryColor,
    awayTeamPrimaryColor
  } = t0;
  const {
    lineups,
    events
  } = useMatch();
  const labels = useLabels();
  const [activeTeam, setActiveTeam] = useState("home");
  let t1;
  if ($[0] !== events) {
    t1 = events || [];
    $[0] = events;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = extractSubstitutions(t1);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const substitutions = t2;
  if (!lineups || !lineups.confirmed) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="text-center py-6 text-muted-foreground text-sm">Lineup data is not available for this match.</div>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] !== homeTeamName) {
    t3 = {
      id: "home" as const,
      label: homeTeamName
    };
    $[5] = homeTeamName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== awayTeamName) {
    t4 = {
      id: "away" as const,
      label: awayTeamName
    };
    $[7] = awayTeamName;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = [t3, t4];
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const teamOptions = t5;
  let t6;
  if ($[12] !== awayTeamCode || $[13] !== awayTeamLogo || $[14] !== awayTeamName || $[15] !== awayTeamPrimaryColor || $[16] !== homeTeamCode || $[17] !== homeTeamLogo || $[18] !== homeTeamName || $[19] !== homeTeamPrimaryColor) {
    t6 = <div className="hidden md:block"><MatchLineupField homeTeamName={homeTeamName} awayTeamName={awayTeamName} homeTeamCode={homeTeamCode} awayTeamCode={awayTeamCode} homeTeamLogo={homeTeamLogo} awayTeamLogo={awayTeamLogo} homeTeamColor={homeTeamPrimaryColor} awayTeamColor={awayTeamPrimaryColor} /></div>;
    $[12] = awayTeamCode;
    $[13] = awayTeamLogo;
    $[14] = awayTeamName;
    $[15] = awayTeamPrimaryColor;
    $[16] = homeTeamCode;
    $[17] = homeTeamLogo;
    $[18] = homeTeamName;
    $[19] = homeTeamPrimaryColor;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== activeTeam || $[22] !== teamOptions) {
    t7 = <div className="flex justify-center"><PillToggle options={teamOptions} activeId={activeTeam} onChange={setActiveTeam} size="sm" /></div>;
    $[21] = activeTeam;
    $[22] = teamOptions;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== activeTeam || $[25] !== awayTeamCode || $[26] !== awayTeamLogo || $[27] !== awayTeamName || $[28] !== awayTeamPrimaryColor || $[29] !== homeTeamCode || $[30] !== homeTeamLogo || $[31] !== homeTeamName || $[32] !== homeTeamPrimaryColor) {
    t8 = <MatchLineupField homeTeamName={homeTeamName} awayTeamName={awayTeamName} homeTeamCode={homeTeamCode} awayTeamCode={awayTeamCode} homeTeamLogo={homeTeamLogo} awayTeamLogo={awayTeamLogo} homeTeamColor={homeTeamPrimaryColor} awayTeamColor={awayTeamPrimaryColor} activeTeam={activeTeam} />;
    $[24] = activeTeam;
    $[25] = awayTeamCode;
    $[26] = awayTeamLogo;
    $[27] = awayTeamName;
    $[28] = awayTeamPrimaryColor;
    $[29] = homeTeamCode;
    $[30] = homeTeamLogo;
    $[31] = homeTeamName;
    $[32] = homeTeamPrimaryColor;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== t7 || $[35] !== t8) {
    t9 = <div className="block md:hidden space-y-4">{t7}{t8}</div>;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== labels || $[38] !== substitutions.away || $[39] !== substitutions.home) {
    t10 = <div className="hidden md:block"><SubstitutionsSection homeSubstitutions={substitutions.home} awaySubstitutions={substitutions.away} labels={labels} /></div>;
    $[37] = labels;
    $[38] = substitutions.away;
    $[39] = substitutions.home;
    $[40] = t10;
  } else {
    t10 = $[40];
  }
  let t11;
  if ($[41] !== activeTeam || $[42] !== labels || $[43] !== substitutions.away || $[44] !== substitutions.home) {
    t11 = <div className="block md:hidden"><SubstitutionsSection homeSubstitutions={substitutions.home} awaySubstitutions={substitutions.away} labels={labels} activeTeam={activeTeam} /></div>;
    $[41] = activeTeam;
    $[42] = labels;
    $[43] = substitutions.away;
    $[44] = substitutions.home;
    $[45] = t11;
  } else {
    t11 = $[45];
  }
  let t12;
  if ($[46] !== t10 || $[47] !== t11) {
    t12 = <div className="bg-card overflow-hidden">{t10}{t11}</div>;
    $[46] = t10;
    $[47] = t11;
    $[48] = t12;
  } else {
    t12 = $[48];
  }
  let t13;
  if ($[49] !== t12 || $[50] !== t6 || $[51] !== t9) {
    t13 = <div className="space-y-4">{t6}{t9}{t12}</div>;
    $[49] = t12;
    $[50] = t6;
    $[51] = t9;
    $[52] = t13;
  } else {
    t13 = $[52];
  }
  return t13;
}